import {
  OutputControlRequest,
  searchChargeUsageStatus,
} from "@/models/chargerUsageStatus";
import {
  ChargePlan,
  searchChargePlans,
  CancelChargePlans,
  Palet,
} from "@/models/chargePlans";
import { AxiosResponse } from "axios";
import { httpClient } from "./API";

export const getChargePlansAPI = async (
  search: searchChargePlans
): Promise<AxiosResponse<ChargePlan<Palet.Plan>>> => {
  return httpClient.get("/core/internal/calgary/chargePlans/chargePlan", {
    params: { ...search },
  });
};

export const cancelChargePlansAPI = async (
  params: CancelChargePlans
): Promise<AxiosResponse<ChargePlan<Palet.Plan>>> => {
  const queryParams = `officeId=${params.officeId}&vehicleCode=${params.vehicleCode}&targetDate=${params.targetDate}&bin=${params.bin}`;
  return httpClient.put(
    `/core/internal/calgary/chargePlans/cancel?${queryParams}`
  );
};

export const getChargerUsageStatusAPI = async (
  search: searchChargeUsageStatus
): Promise<AxiosResponse<ChargePlan<Palet.Usage>>> => {
  return httpClient.get("/core/internal/calgary/chargePlans/chargerUse", {
    params: { ...search },
  });
};

export const cancelOutputControlChargerUsageStatusAPI = async (
  params: OutputControlRequest
): Promise<AxiosResponse<number>> => {
  return httpClient.put(
    `/core/internal/calgary/chargePlans/chargerUse/cancelOutputControl?chargerId=${params.chargerId}&targetDate=${params.targetDate}`
  );
};
